export const customStyles = (isFocused, formActive, isMobile) => ({
  control: (provided) => ({
    ...provided,
    boxShadow: null,
    border: 'none',
    minHeight: 0,
    backgroundColor: 'transparent',
    flex: 1,
    cursor: 'text'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: formActive && !isFocused ? '#AEAFBD' : '#6A6E7A',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    transition: 'all 0.2s ease',
    fontSize: isMobile ? '18px' : '16px',
    lineHeight: '24px'
  }),
  input: (provided) => ({
    ...provided,
    color: formActive && !isFocused ? '#AEAFBD' : '#121212',
    margin: 0,
    transition: 'all 0.2s ease',
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: isMobile ? '18px' : '16px',
    lineHeight: '24px'
  }),
  option: (provided, state) => {
    const optionStyles = {
      ...provided,
      backgroundColor: state.isFocused ? '#E9EBEF' : null,
      color: '#121212',
      cursor: 'pointer',
      padding: '8px 16px'
    };
    if (!isMobile) {
      optionStyles['&:hover'] = {
        backgroundColor: '#E9EBEF'
      };
    }
    return optionStyles;
  },
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    width: '0px',
    overflow: 'hidden'
  }),
  menu: (provided) => {
    return {
      ...provided,
      left: 0,
      right: 0,
      margin: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: '2px',
      borderBottomRightRadius: '2px',
      boxShadow: 'none'
    };
  },
  container: (provided) => {
    return {
      ...provided,
      position: 'static',
      display: 'flex',
      flex: isMobile ? 0 : 1
    };
  }
});
